import * as React from 'react'
import * as Redux from 'react-redux'
import { css, styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import * as shadow from '@owl-nest/shadow'
import * as model from '@owl-nest/models'

import { DisplayMode } from '../../../../context'
import * as projectModel from '../../../../models/project'
import { type RootState } from '../../../../../reducers'
import { MIDDLE_TABLET_LAPTOP_BREAKPOINT } from '../../constants'

export function PartnerRibbon(): React.ReactElement<unknown> | null {
  const ribbonRef = React.useRef(null)

  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const partnerRibbonData = model.project.getRibbonData(project)
  const isEditMode = React.useContext(DisplayMode) === 'edit'

  shadow.usePartnershipTracker(partnerRibbonData?.partnerOwnerId, ribbonRef, {
    click: {
      enabled: false,
    },
    eventPosition: 'project-page-ribbon',
    impression: {
      enabled: true,
      once: true,
    },
  })

  if (partnerRibbonData && partnerRibbonData.ribbonImageUrl) {
    return (
      <Ribbon $backgroundUrl={partnerRibbonData.ribbonImageUrl} $isEditMode={isEditMode} ref={ribbonRef}>
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        {!isEditMode && <a href={partnerRibbonData.partnerUrl} target="_blank" rel="nooponer noreferrer" />}
      </Ribbon>
    )
  }

  return null
}

const ribbontBreakpointStyle = css`
  height: 160px;
  width: 177px;
  right: -1px;
  top: -1px;

  a {
    height: 160px;
    width: 177px;
  }
`

export const Ribbon = styled.div<{ $backgroundUrl: string; $isEditMode: boolean }>`
  background-image: ${({ $backgroundUrl }) => `url('${$backgroundUrl}')`};
  background-repeat: no-repeat;
  background-size: cover;
  height: 90px;
  position: absolute;
  right: 0px;
  top: 0px;
  width: 103px;
  opacity: ${({ $isEditMode }) => ($isEditMode ? '50%' : '100%')};
  pointer-events: ${({ $isEditMode }) => ($isEditMode ? 'none' : 'all')};
  z-index: 2;

  a {
    display: block;
    height: 90px;
    position: absolute;
    right: 0;
    top: 0;
    width: 103px;
  }

  ${({ $isEditMode }) => {
    if ($isEditMode) {
      return css`
        @media screen and ${plume.BREAKPOINTS.LAPTOP} {
          ${ribbontBreakpointStyle};
        }
      `
    } else {
      return css`
        @media screen and ${MIDDLE_TABLET_LAPTOP_BREAKPOINT} {
          ${ribbontBreakpointStyle};
        }
      `
    }
  }}
`
